import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  AppBar as MatAppBar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AvatarMenu } from 'components';
import { COMPANY_TITLE } from 'constants/index';
import { UiHeader, UiToolbar, UiLogo } from './Header.style';
import getStatic from 'utils/getStatic';

const isCompany = process.env.REACT_APP_TITLE === COMPANY_TITLE;
const homeLogo = process.env.REACT_APP_LOGO || getStatic('home_logo');

/**
 * Header
 */
const useStyles = makeStyles({
	paper: {
		boxShadow: '1px 2px 5px 1px rgba(0, 0, 0, 0.3)',
	},
});
export const Header = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <UiHeader>
      <MatAppBar className={classes.paper} position="static">
        <UiToolbar>
          <UiLogo onClick={() => { history.push('/home'); }}>
            <img src={homeLogo} alt={isCompany ? 'oneClass' : process.env.REACT_APP_TARGET_ID} />
          </UiLogo>
          <AvatarMenu />
        </UiToolbar>
      </MatAppBar>
    </UiHeader >
  );
};
